// Representative flat colour for each item (block or tool), used by 2D UI
// (hotbar, inventory) and the held-item viewmodel tint.

import { Block } from '../sim/blocks';
import { isBlockItem, Item } from '../sim/items';

const BLOCK_SWATCH: Record<number, string> = {
  [Block.Grass]: '#5f9f35',
  [Block.Dirt]: '#78553a',
  [Block.Stone]: '#808084',
  [Block.Sand]: '#dbcd96',
  [Block.Wood]: '#6e5232',
  [Block.Leaves]: '#3a782e',
  [Block.Planks]: '#a8844e',
  [Block.Cobblestone]: '#6e6e72',
  [Block.Torch]: '#e6be46',
  [Block.CraftingTable]: '#96744a',
};

const TOOL_SWATCH: Record<number, string> = {
  [Item.Stick]: '#b0854e',
  [Item.WoodPickaxe]: '#8a6a3f',
  [Item.WoodAxe]: '#8a6a3f',
  [Item.WoodSword]: '#a07c48',
  [Item.StonePickaxe]: '#9a9aa0',
  [Item.StoneAxe]: '#9a9aa0',
  [Item.StoneSword]: '#b6b6bc',
};

export function itemSwatch(id: number): string {
  if (isBlockItem(id)) return BLOCK_SWATCH[id] ?? '#999';
  return TOOL_SWATCH[id] ?? '#bbb';
}

export function blockSwatch(block: Block): string {
  return BLOCK_SWATCH[block] ?? '#999';
}
